<template>
  <div class="main-chapter1">
    <div class="chapter-title">Список инженерно-технического персонала, занятого на строительстве объекта</div>
    <n-table :columns="columns" :data="data" :loading="this.$var('load')">
      <template #participant="{item}">
        {{ item.fullName }} <span style="opacity: .8;font-size: .8em">[{{ item.iin }}]</span>
      </template>
      <template #startedAt="{item}">
        {{ $app.date.format(item.participant.createdAt ) }}
      </template>
      <template #document="{item}">
        <div class="open-documents" @click="$var('user', item)">Документы пользователя</div>
        <a v-if="item.participant.file" :href="item.participant.file">Приказ</a>
      </template>
    </n-table>

    <user-documents v-if="$var('user')" :user="$var('user')" @close="$var('user', false)" />
  </div>
</template>

<script>
import UserDocuments from 'components/userDocuments/Index'

export default {
  name: 'MainChapter2',
  components: { UserDocuments, },
  props: [ 'project', ],
  data: () => ({
    columns: [
      { name: 'participant', title: 'Должность, фамилия, инициалы, участок работ', },
      { name: 'startedAt', title: 'Дата начала работ на строительстве объекта', },
      { name: 'document', title: 'Отметка о получении разрешения на право производства работ, о прохождении аттестации', },
      { name: 'endedAt', title: 'Дата окончания работ на строительстве объекта', },
    ],
    data: [],
  }),
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.main.two.get(this.project.id).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    .open-documents {
      cursor: pointer;
      color: var(--primary);
    }
  }
</style>
